import AppTitle from '@theme/components/atom/AppTitle'
import BranchMixin from '~/mixins/BranchMixin'
import Container from '@theme/components/utils/Container'
import GoogleMap from '@theme/components/utils/GoogleMap/GoogleMapLazy'
import HeadingLevel from '~/mixins/HeadingLevel'

export default {
  props: {
    branches: {
      type: [Array, Boolean],
      default: false,
    },
  },
  components: {
    AppTitle,
    Container,
    GoogleMap,
  },
  mixins: [BranchMixin, HeadingLevel],
  data() {
    return {
      markers: [],
      selectedRegionFilter: '',
      services: [],
    }
  },
  async mounted() {
    await this.getMarkers()
    this.getServices()
  },
  computed: {
    regions() {
      return [...new Set(this.markers.map(marker => marker.region))].sort((a, b) => {
        return a.localeCompare(b)
      })
    },
    filteredMarkers() {
      // .some() => use if marker must contain at least one selected service
      // .every() = use if marker must contain all selected services
      return this.markers
        .filter(marker => (this.selectedRegionFilter ? marker.region === this.selectedRegionFilter : true))
        .filter(
          marker =>
            this.selectedServices.length
              ? this.selectedServices.some(service => marker.services.includes(service.name))
              : true,
        )
    },
    selectedServices() {
      return this.services.filter(service => service.selected)
    },
  },
  methods: {
    async getMarkers() {
      this.markers = (await this.getBranches())
        .filter(
          branch =>
            branch.gps_latitude &&
            branch.gps_longitude &&
            branch.region &&
            branch.region.length > 0 &&
            branch.services &&
            branch.services.length > 0,
        )
        .map(branch => ({
          ...branch,
          image: branch.branch_map_images && branch.branch_map_images.length > 0 && branch.branch_map_images[0].path,
          position: {
            lat: branch.gps_latitude,
            lng: branch.gps_longitude,
          },
          markerDescription: this.compileBranchDescriptionForGoogleMapMarker(
            branch.opening_hours,
            branch.branch_map_description,
          ),
          region: branch.region[0],
        }))
    },
    async getBranches() {
      if (this.branches && this.branches.length) {
        return this.branches
      } else {
        const { entities } = await this.$store.dispatch('branch/LOAD_BRANCHES_MAP_DATA')
        return entities
      }
    },
    getServices() {
      // .map() => creates a new array with all services from markers as nested array
      // .flat() => creates a new array with all sub-array elements concatenated into it recursively
      // new Set() => creates a new array without duplications
      // Array.from() => create a new array with object items according definition
      // .sort() => sorts the elements of an array by translated labels
      this.services = Array.from([...new Set(this.markers.map(marker => marker.services).flat())], x => {
        return {
          label: this.$t('BranchesMap.services.' + x),
          name: x,
          selected: false,
        }
      }).sort((a, b) => {
        return a.label.localeCompare(b.label)
      })
    },
  },
}
